import type { AnyRouter } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import clsx from "clsx";
import { useEffect, useId } from "react";

type TanStackRouterDevtoolsProps = {
  router: AnyRouter;
  isOpen: boolean;
};

export function TanstackRouterDevtools({
  router,
  isOpen,
}: TanStackRouterDevtoolsProps) {
  const openButtonId = useId();

  useEffect(() => {
    const btn: HTMLButtonElement | null = document.querySelector(
      isOpen ? `#${openButtonId}` : ".TanStackRouterDevtoolsPanel > button",
    );

    btn?.click();
  }, [isOpen, openButtonId]);

  useEffect(() => {
    localStorage.setItem("tanstackRouterDevtoolsOpen", "false");
  }, []);

  return (
    <div
      className={clsx([
        "[&_.TanStackRouterDevtoolsPanel]:min-h-[60dvh]!",
        "[&_.TanStackRouterDevtoolsPanel>button]:hidden!",
      ])}
    >
      <TanStackRouterDevtools
        router={router}
        initialIsOpen={false}
        toggleButtonProps={{
          id: openButtonId,
          style: { display: "none" },
        }}
      />
    </div>
  );
}
